import React from "react";

function SvgHouse({
  color = "currentColor",
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M1.66699 18.3333H18.3337"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.45801 18.3334L2.49968 8.30836C2.49968 7.80003 2.74134 7.31674 3.14134 7.00008L8.97467 2.4584C9.57467 1.99173 10.4163 1.99173 11.0247 2.4584L16.858 6.99173C17.2663 7.3084 17.4997 7.7917 17.4997 8.30836V18.3334"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M12.9163 9.16675H7.08301C6.39134 9.16675 5.83301 9.72508 5.83301 10.4167V18.3334H14.1663V10.4167C14.1663 9.72508 13.608 9.16675 12.9163 9.16675Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33301 13.5417V14.7917"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 6.25H11.25"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgHouse;
